import globals from '../../common/globals';
import {
  leftNavigation,
} from '../../common/mixins/vx-enums';

export default {
  name: 'vx-left-nav',
  components: {},
  mixins: [],
  props: {
    /**
     * Left navigation data
     */
    leftNavData: {
      type: Array,
      required: true,
    },
    // Text and label from properties file
    i18n: Object,
    // Flag to show or hide the company section (for B2B)
    showCompanySection: Boolean,
  },
  data() {
    return {
      navigationData: this.leftNavData,
      currentUrlPath: window.location.pathname.substring(window.location.pathname.indexOf('/', 1)),
      baseURL: globals.getNavBaseUrl(),
      userInfo: globals.userInfo.userRoles,
      leftNavigation,
      globals,
    };
  },
  computed: {},
  mounted() {},
  methods: {},
};



// WEBPACK FOOTER //
// ./src/components/manage-profile-shopping-lists/vx-left-nav/vx-left-nav.js